module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-container', [(_vm.type === 'post/carousel' || _vm.type === 'reel') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.engagement !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.engagement)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.saved && _vm.post.saved !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.saved)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views && _vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays && _vm.post.plays !== '0h:0m:0s' && _vm.post.plays !== 'h:m:s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches && _vm.post.watches !== '0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Average Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.post.type !== 'story') ? _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.igPost)
    }
  })]) : _vm._e()], 1)], 1)], 1) : (_vm.type === 'story') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.storyTotalInteractions !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.storyTotalInteractions)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.link_clicks !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Link Clicks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.link_clicks)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.replies !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.replies)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.sticker_taps !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Sticker Taps")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.sticker_taps)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.MEDIA_URL_TYPE === 'video') ? _c('video', {
    attrs: {
      "width": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.POST_URL,
      "type": "video/mp4"
    }
  }), _vm._v("\n                        Your browser does not support HTML5 video.\n                      ")]) : (_vm.MEDIA_URL_TYPE === 'image') ? _c('img', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "src": _vm.POST_URL
    }
  }) : (_vm.MEDIA_URL_TYPE === 'driveView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.POST_URL,
      "darkTheme": true
    }
  }) : (_vm.MEDIA_URL_TYPE === 'cld') ? _c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans
    }
  }) : (_vm.MEDIA_URL_TYPE === 'iframe') ? _c('iframe', {
    staticClass: "media-iframe",
    attrs: {
      "height": "100%",
      "src": _vm.POST_URL,
      "allowFullScreen": ""
    }
  }) : _c('div', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_c('v-alert', {
    attrs: {
      "width": "350"
    }
  }, [_vm._v("\n                          Media type unsupported!\n                        ")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'tiktok') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tik-tok-pink.png",
      "width": "36px"
    }
  }), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.engagement !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.engagement)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.saved && _vm.post.saved !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.saved)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays !== 0 && _vm.post.plays !== '0h:0m:0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Play Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0 && _vm.post.watches !== '0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Average Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watchedFullVideo !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watched Full Video")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watchedFullVideo)) + "%")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.photo_views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Photo Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.photo_views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.tikTokPost) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "src": _vm.tikTokPost,
      "allow": "fullscreen"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'youtube') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fab fa-youtube pr-3",
    staticStyle: {
      "font-size": "36px",
      "color": "#dd2476"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.youtubePost) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "src": _vm.youtubePost,
      "allow": "fullscreen"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'facebook') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.getFbPost(_vm.post.url),
      "allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
      "allowfullscreen": "true",
      "scrolling": "no"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'xhs') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.download(_vm.getMedia(_vm.post).URL)
      }
    }
  }, [_vm._v("\n                              Download\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.xhsLink)
      }
    }
  }, [_vm._v("\n                              View on XHS\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'lemon') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.download(_vm.getMedia(_vm.post).URL)
      }
    }
  }, [_vm._v("\n                              Download\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.lemonLink)
      }
    }
  }, [_vm._v("\n                              View on Lemon8\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'linkedin') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "#0A66C2"
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('div', [_vm._v("LinkedIn Post - @" + _vm._s(_vm.post.name))])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "linkedin-insights"
  }, [(_vm.hasPositiveMetric(_vm.post.impressions)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Impressions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.impressions || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.reach)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Members reached")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.reach || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.like_count)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.like_count || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.comment_count)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.comment_count || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.shares)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reposts")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.shares || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.saved != null ? _vm.post.saved : _vm.post.bookmarks)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Saves")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.saved || _vm.post.bookmarks || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7",
      "align": "center"
    }
  }, [(_vm.getLinkedInEmbedUrl(_vm.post.url)) ? _c('iframe', {
    staticClass: "linkedin-post-embed",
    attrs: {
      "src": _vm.getLinkedInEmbedUrl(_vm.post.url),
      "title": ("LinkedIn post by " + (_vm.post.name)),
      "width": "100%",
      "height": "560",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _c('v-alert', {
    attrs: {
      "width": "500"
    }
  }, [_vm._v("This LinkedIn post cannot be embedded.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "small": "",
      "color": "secondary",
      "href": _vm.post.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                          View on LinkedIn\n                          "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-linkedin")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'twitter') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "mr-2",
    staticStyle: {
      "filter": "invert(1)"
    },
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "24px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twitter-report-title-text"
  }, [_vm._v("X (Twitter) Post · @" + _vm._s(_vm.post.name))])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "twitter-insights"
  }, [(_vm.twitterMetric(_vm.post, 'impressions') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Impressions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'impressions'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'replies') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'replies'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'likes') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'likes'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'reposts') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reposts")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'reposts'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'bookmarks') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'bookmarks'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7",
      "align": "center"
    }
  }, [(_vm.getTwitterEmbedUrl(_vm.post.url)) ? _c('div', {
    staticClass: "twitter-embed-viewport"
  }, [_c('iframe', {
    staticClass: "twitter-post-embed",
    attrs: {
      "src": _vm.getTwitterEmbedUrl(_vm.post.url),
      "title": ("X post by " + (_vm.post.name)),
      "width": "100%",
      "height": "560",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]) : _c('v-alert', {
    attrs: {
      "width": "500"
    }
  }, [_vm._v("This X post cannot be embedded.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "small": "",
      "color": "secondary",
      "href": _vm.post.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                          View on X\n                          "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'others') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays !== 0 && _vm.post.plays !== '0h:0m:0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Play Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [(_vm.post.media_type === 'video') ? _c('video', {
    attrs: {
      "width": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.post.url,
      "type": "video/mp4"
    }
  }), _vm._v("\n                            Your browser does not support HTML5 video.\n                          ")]) : (_vm.post.media_type === 'image') ? _c('img', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "src": _vm.post.url
    }
  }) : _c('div', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_c('v-alert', {
    attrs: {
      "width": "350"
    }
  }, [_vm._v("\n                              Media type unsupported!\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.embed_url)
      }
    }
  }, [_vm._v("\n                            Download\n                            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.postLink)
      }
    }
  }, [_vm._v("\n                            View\n                            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)])], 1)], 1)], 1) : (_vm.type === 'gdrive') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.storyTotalInteractions && _vm.post.storyTotalInteractions !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.storyTotalInteractions)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.link_clicks && _vm.post.link_clicks !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Link Clicks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.link_clicks)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.replies && _vm.post.replies !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.replies)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.sticker_taps && _vm.post.sticker_taps !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Sticker Taps")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.sticker_taps)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": true
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5960f951"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/posts.vue
// module id = 2139
// module chunks = 0